<template>
  <div class="d-flex col-6" @click="showStarOptions = true">
    <img
      @click="emitContent(option)"
      v-for="option in +info.extension_info.level"
      :key="option"
      class="col-1 mx-1 mt-2"
      :src="imgAry[option - 1]"
    />
  </div>
</template>
<script>
import { ref, watch } from '@vue/runtime-core'
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    iconList: {
      type: Array,
      default: () => [],
    },
    iconStyle: {
      type: Number,
      default: 0,
    },
    star_num: {
      type: Number,
      default: 5,
    },
    order: {
      type: Number,
      default: 0,
    },
    value: {
      type: [String, Array, Number],
      default: undefined,
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const iconList = ref(['star', 'heart', 'check', 'good'])
    const getImg = (star) => {
      return new Array(+props.info.extension_info.level)
        .fill('0')
        .map((v, i) => {
          if (i + 1 <= star) {
            return require(`@/assets/icons/${
              iconList.value[props.info.extension_info.type - 1]
            }-color.svg`)
          } else {
            return require(`@/assets/icons/${
              iconList.value[props.info.extension_info.type - 1]
            }.svg`)
          }
        })
    }
    const emitContent = async (score) => {
      emit('content', {
        order: props.order,
        id: props.id,
        type: '10',
        value: score,
      })
      imgAry.value = getImg(score)
    }
    const imgAry = ref(getImg())
    watch(
      () => props.value,
      (newValue) => {
        imgAry.value = getImg(newValue)
      },
      { immediate: true },
    )

    return {
      emitContent,
      imgAry,
    }
  },
}
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #321fdb;
  outline: none;
}
.remark {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #321fdb;
  outline: none;
  font-size: 13px;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.content {
  background-color: #fff !important;
  border: 1px solid #bdbdbd;
}
.wrapper {
  border-left: 5px solid #321fdb;
}
</style>
